import React, {memo} from "../../../__snowpack__/pkg/react.js";
const Hot = memo((props) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /* @__PURE__ */ React.createElement("title", null, "\u7F16\u7EC4\u5907\u4EFD"), /* @__PURE__ */ React.createElement("g", {
    id: "\u9875\u9762-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u4E3B\u5546\u54C1\u5217\u8868\u5907\u4EFD-6",
    transform: "translate(-776.000000, -371.000000)"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4\u5907\u4EFD",
    transform: "translate(776.000000, 370.999986)"
  }, /* @__PURE__ */ React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "2.05128199e-05",
    width: "24",
    height: "24"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.93653025,23.7000205 C8.26397442,22.5647676 7.56392355,20.4075653 8.18811932,18.2156865 C9.08278043,16.017961 9.77737129,14.4353406 9.77737129,14.4353406 C9.77737129,14.4353406 10.7621225,15.7659514 10.372122,17.8427122 C12.1173742,15.8266353 12.4490696,12.6309518 12.1858193,11.4011449 C16.1443242,14.2540953 17.8312713,18.9094185 15.5495734,23.4859131 C27.6694234,16.4092815 18.5625222,5.82447449 16.9830202,4.62470712 C17.5095209,5.82447449 17.606826,7.84055141 16.5440747,8.81855033 C14.7405174,1.7517975 10.2748169,0.300020513 10.2748169,0.300020513 C10.8013176,3.94932135 8.35386953,7.93127487 6.00392162,10.9150687 C5.91617151,9.46369494 5.8286164,8.45545487 5.08742049,7.06416019 C4.92167028,9.70542257 2.96191786,11.8628265 2.43541721,14.5038872 C1.72366633,18.0927058 2.97166787,20.7136058 7.73961877,23.4859131 C7.73961877,23.4859131 8.24115939,23.7000205 8.93653025,23.7000205",
    id: "Fill-1",
    fill: "currentColor"
  })))));
});
export default Hot;
